import styled from '@emotion/styled'

export const Page = styled('div')<{ scrollable: boolean }>(
    ({ scrollable }) => ({
        overflow: scrollable ? 'auto' : 'hidden',
        maxHeight: scrollable ? 'auto' : '100vh',
    }),
)
